export default __webpack_public_path__ + "static/media/eva-cutout.55738ff5.png";